import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const Component = ({
  textAlign = 'left',
  fontSize = '36px',
  width = '100%',
  allowDecimal,
  decimalLimit,
  keyValue,
  ...props
}) => (
  <MaskedInput
    key={keyValue}
    style={{
      width,
      border: 'none',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: '#767676',
      fontSize,
      textAlign,
      paddingRight: '12px',
    }}
    mask={createNumberMask({
      prefix: '',
      allowDecimal,
      decimalLimit,
    })}
    guide={false}
    maxLength={20}
    {...props}
  />
);

Component.displayName = 'QuantityField';

Component.propTypes = {
  decimalLimit: PropTypes.number,
  allowDecimal: PropTypes.bool,
};

Component.defaultProps = {
  decimalLimit: 5,
  allowDecimal: true,
};

export default Component;



// WEBPACK FOOTER //
// ./src/components/Forms/Controls/QuantityField.js